module.exports = __webpack_public_path__ + "img/ico_carta.f29fccf9.svg";